import {Component, EventEmitter, Input, Output} from '@angular/core';
import { faTimes, faPlus } from '@fortawesome/free-solid-svg-icons';
import {TaxExpense} from './list-item.model';


@Component({
    selector: 'app-editable-list',
    templateUrl: './editable-list.component.html',
    styleUrls: ['./editable-list.component.css']
})
export class EditableListComponent {
    @Input() listItems: TaxExpense[] = [];
    @Output() listItemsChange = new EventEmitter<TaxExpense[]>();

    faTimes = faTimes;
    faPlus = faPlus;

    addRow(): void {
        this.listItems.push({ name: '', value: null });
        this.listItemsChange.emit(this.listItems);
    }

    removeRow(index: number): void {
        this.listItems.splice(index, 1);
        this.listItemsChange.emit(this.listItems);
    }

    onItemChange(): void {
        this.listItemsChange.emit(this.listItems);
    }
}
